import { Panel } from "../../../components/panels/Panel";
import {
  CARTS,
  findPoolById, getCartColor,
  getCartName,
  POOLS_GROUPS_LINE_1
} from "../../../services/live-interface/dior-interface-service";
import { formatSecondsToHoursMinutesSeconds, formatSecondsToMinutesSeconds } from "../../../helpers/date/date-helper";


const DiorKanbanCard = ({ pool, poolData, poolIndex, cartErrors }) => {
  const percent = pool !== null ? Math.min(poolData.value / pool.value * 100, 100) : null;

  return (
    <div className="w-full bg-perception-black-700 rounded-md mb-4 p-4">

        {/* Header */}
        <div className="w-full">
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <div className="size-3 mr-2 rounded-full" style={{ backgroundColor: getCartColor(poolData.tag_id, CARTS) }} />
              <span className="font-semibold">{getCartName(poolData.tag_id, CARTS)}</span>
            </div>
            {
              poolIndex !== null ?
                <div className="bg-perception-blue text-white text-xs px-2 py-1 rounded-md">In progress</div> :
                <div className="bg-perception-success-300 text-white text-xs px-2 py-1 rounded-md">Finished</div>

            }
          </div>
          {
            poolIndex !== null &&
              <div className="flex justify-end">
                <div className="text-xs bg-perception-black-800 px-2 py-1 rounded-md mt-2">
                  Pool #{poolIndex + 1}
                </div>
              </div>
          }
        </div>

        {/* Progress bar */}
        {
          poolIndex !== null &&
            <div className="flex flex-col">
              <div className="text-sm text-perception-gray-600">Progress</div>
              <div className="flex items-center gap-2">
                <div className="flex-1 h-2 rounded-full bg-perception-black-800 overflow-hidden">
                  <div className="h-full bg-perception-blue rounded-full" style={{ width: percent + '%'}} />
                </div>
                <span className="text-sm text-gray-300">{Math.round(percent)}%</span>
              </div>
            </div>
        }

        {/* Times */}
        <div className="flex justify-between mt-4 text-sm text-gray-400">
          <div>
            <span className="mr-2">Start:</span>
            <span className="font-semibold text-white">{formatSecondsToHoursMinutesSeconds(poolData.start_time)}</span>
          </div>
          <div>
            <span className="mr-2">{poolIndex !== null ? 'Estimated end' : 'End'}:</span>
            <span className="font-semibold text-white">
              {
                poolIndex === null ?
                  formatSecondsToHoursMinutesSeconds(poolData.stop_time) :
                  formatSecondsToHoursMinutesSeconds(poolData.start_time + pool.value)
              }
            </span>
          </div>
        </div>

        {/* Remaining time */}
        {
          poolIndex !== null &&
            <div className="flex mt-2 text-sm text-gray-400">
              <span className="mr-2">Time remaining:</span>
              <span className="text-blue-400 font-semibold">{formatSecondsToMinutesSeconds(Math.max(pool.value - poolData.value, 0))}</span>
            </div>
        }

        {/* Errors */}
        <div className="bg-perception-black-500 rounded-md mt-4 p-2 text-sm">
          {
            cartErrors?.length > 0 ?
              <div className="flex flex-col gap-2">
                {cartErrors.length} error(s) reported
                <div className="flex justify-start gap-2">
                  {
                    cartErrors.map((poolId) =>
                      <div className="rounded-full text-xs px-2 text-nowrap text-center bg-error text-white w-auto">
                        Pool #{poolId + 1}
                      </div>
                    )
                  }
                </div>
              </div>
            :
              <div className="text-center">No error detected</div>
          }
        </div>
    </div>
  );
};

export const DiorKanban = ({ currentData, cartsErrors, cartsFinished }) => {
  return (
    <Panel title="CART TRACKING" width="w-2/5" className="rounded-md">
      <div className="w-full h-full flex gap-4">
        <div className="w-1/2 bg-perception-black-500 rounded-md p-4 overflow-y-auto">
          {
            currentData.map((poolData, poolIndex) => {
              const tagId = poolData?.tag_id;
              if (tagId === undefined || tagId === null) return null;

              const pool = findPoolById(poolIndex, POOLS_GROUPS_LINE_1);
              return (
                <div key={poolIndex}>
                  <DiorKanbanCard pool={pool} poolData={poolData} poolIndex={poolIndex} cartErrors={cartsErrors[tagId]}/>
                </div>
              )
            })
          }
        </div>
        <div className="w-1/2 bg-perception-black-500 rounded-md p-4">
          {
            cartsFinished.map((cart, index) =>
              <div key={index}>
                <DiorKanbanCard pool={null} poolData={cart} poolIndex={null} cartErrors={cartsErrors[cart.tag_id]}/>
              </div>
            )
          }
        </div>
      </div>
    </Panel>
  );
};